<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Document') : $t('New Document')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="formValues.name"
                  label="Name"
                  v-validate="'required'"
                  required
                  data-vv-name="name"
                  :error-messages="errors.collect('name')"
                ></v-text-field>
                <!-- <v-combobox
                  :items="formValues.type"
                  v-model="formValues.type"
                  chips
                  :label="$t('types')"
                  multiple
                  disabled
                  class="mt-4"
                >
                  <template v-slot:selection="{ attrs, item }">
                    <v-chip v-bind="attrs">
                      <strong>{{ item }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
                <v-text-field
                  v-model="formValues.type"
                  label="Type"
                  v-validate="''"
                  required
                  data-vv-name="type"
                  :error-messages="errors.collect('type')"
                ></v-text-field> -->
                <base-date-picker
                  v-model="formValues.expire"
                ></base-date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-combobox
                  v-model="formValues.tags"
                  :items="tags"
                  chips
                  clearable
                  label="Tags"
                  multiple
                  prepend-icon="mdi-filter"
                  solo
                  class="mt-4"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click="select"
                      @click:close="removeTag(item)"
                    >
                      <strong>{{ item }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-tabs v-model="tab" background-color="gray" dark right>
                <v-tab key="items">{{ $t("items") }}</v-tab>
                <v-tab key="door_types">{{ $t("doortypes") }}</v-tab>
                <v-tabs-items v-model="tab">
                  <v-tab-item key="items">
                    <v-card>
                      <v-data-table
                        :headers="itemHeaders"
                        :items="this.formValues.items"
                        :loading="loading"
                        :multi-sort="true"
                        class="elevation-1"
                        :footer-props="{
                          'items-per-page-options': [10, 15, 50, -1]
                        }"
                      >
                        <template v-slot:item.code="{ item }">
                          <a
                            @click="
                              $router.push({
                                name: 'item.edit',
                                params: { id: item.id }
                              })
                            "
                          >
                            {{ item.code }}</a
                          >
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="door_types">
                    <v-card>
                      <v-data-table
                        :headers="doorTypeHeaders"
                        :items="this.formValues.door_types"
                        :loading="loading"
                        :multi-sort="true"
                        class="elevation-1"
                        :footer-props="{
                          'items-per-page-options': [10, 15, 50, -1]
                        }"
                      >
                        <template v-slot:item.code="{ item }">
                          <a
                            @click="
                              $router.push({
                                name: 'doorType.edit',
                                params: { id: item.id }
                              })
                            "
                          >
                            {{ item.code }}</a
                          >
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-row>
            <v-row>
              <v-col cols="6">
                <base-file-uploader v-model="fileData"></base-file-uploader>
              </v-col>
            </v-row>
            <v-card-actions class="pl-0">
              <v-btn
                color="secondary"
                class="mr-4"
                @click="$router.push({ name: 'document.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-btn
                v-if="this.$route.params.id"
                color="error"
                class="mr-4"
                @click="deleteItem"
              >
                {{ $t("delete") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  saveItem,
  fetchItem,
  deleteItem,
  fetchDocumentTags
} from "../shared/services";
export default {
  name: "app-document-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: ""
      },
      fileData: {},
      permissions: [],
      loading: true,
      itemHeaders: [
        {
          text: "Code",
          align: "left",
          value: "code"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Type",
          align: "left",
          value: "type"
        },
        {
          text: "Category",
          align: "left",
          value: "category.name"
        }
      ],
      doorTypeHeaders: [
        {
          text: "Code",
          align: "left",
          value: "code"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        }
      ],
      tags: [],
      tab: 0
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
        this.fileData.path = this.formValues.path;
        this.fileData.mime_type = this.formValues.mime_type;
        this.fileData.url = this.formValues.url;
        this.fileData.thumb = this.formValues.thumb;
        this.fileData.name = this.formValues.name;
        this.fileData.preview = this.formValues.preview;
      });
    } else {
      this.loading = false;
    }
    fetchDocumentTags().then(res => {
      this.tags = res.data;
    });
  },
  computed: {
    computedFormValues() {
      let fileData = {
        path: this.fileData.path ? this.fileData.path : this.formValues.path,
        mime_type: this.fileData.mime_type
          ? this.fileData.mime_type
          : this.formValues.mime_type
      };

      this.$delete(this.formValues, "image_data");

      return {
        ...this.formValues,
        ...fileData
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "document.index" });
      }
    },
    async deleteItem() {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Document?")
        )
      ) {
        let resp = await deleteItem(this.$route.params.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
          this.$router.push({ name: "document.index" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },

    removeTag(item) {
      this.formValues.tags.splice(this.formValues.tags.indexOf(item), 1);
      this.formValues.tags = [...this.formValues.tags];
    }
  },
  watch: {
    fileData() {
      if (!this.formValues.name) {
        this.formValues.name = this.fileData.name;
      }
      this.formValues.path = this.fileData.path;
      this.formValues.mime_type = this.fileData.mime_type;
      this.formValues.img_data = this.fileData.img_data;
    }
  }
};
</script>

<style lang="scss" scoped></style>
